export function addCurrent(multihirer) {
    return {
        type: 'ADD_CURRENT',
        multihirer,
    }
}
